exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toolsHeader {\n  font-size: 2em;\n  font-weight: bold;\n  padding-bottom: 0em; }\n\n.categoryHeader {\n  font-size: 1.5em;\n  font-weight: 500; }\n\n.button-group {\n  margin-left: .5em; }\n\n.multi-expand {\n  margin-left: .5em;\n  padding-top: 1em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/charles/Documents/AState-Senior/HCI/proj/amd2/src/app/tools/tools.component.scss
// module id = ../../../../../src/app/tools/tools.component.scss
// module chunks = main